import { DataProcessing, PaginationType } from './TanstackTable.types';

export interface ValidateTanstackTableOptionsParams {
  dataProcessing: DataProcessing;
  paginationType: PaginationType;
  onLoadMore?: (cursor: string) => void;
}

/**
 * Validates TanstackTable option combinations. Throws with a clear message when
 * an invalid combination is used (e.g. cursor + client, or virtual_scroll without required props).
 */
export function validateTanstackTableOptions({
  dataProcessing,
  paginationType,
  onLoadMore,
}: ValidateTanstackTableOptionsParams): void {
  if (paginationType === 'cursor' && dataProcessing === 'client') {
    throw new Error(
      'Cursor pagination is not supported for client data processing'
    );
  }
  if (paginationType === 'virtual_scroll') {
    if (dataProcessing !== 'server') {
      throw new Error(
        'Virtual scroll (paginationType="virtual_scroll") requires dataProcessing="server"'
      );
    }
    if (typeof onLoadMore !== 'function') {
      throw new Error(
        'Virtual scroll requires onLoadMore(cursor: string) => void'
      );
    }
  }
}
